<template>
  <b-overlay :show="isLoading">
    <b-row v-if="defaultLessonDetails">
      <b-col cols="12">
        <b-card>
          <h1>ویرایش کلاس {{ defaultLessonDetails.title }}</h1>
          <!-- درس‌های پکیج دوره ندارند؛ بدون این شرط صفحه رندر نمی‌شد -->
          <p v-if="defaultLessonDetails.course" class="my-1">از دوره‌ی {{ defaultLessonDetails.course.title }}</p>
          <b-form class="p-2" @submit.prevent>
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="عنوان جلسه" :label-for="`title`">
                  <b-form-input
                    :id="`title`"
                    v-model="lessonDetails.title"
                    trim
                    placeholder="عنوان جلسه"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="قیمت جلسه" :label-for="`price`">
                  <b-form-input
                    :id="`price`"
                    v-model="lessonDetails.price"
                    trim
                    placeholder="قیمت جلسه"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="توضیحات جلسه" :label-for="`desc`">
                  <b-form-textarea
                    :id="`desc`"
                    v-model="lessonDetails.description"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-between">
                  <b-form-group label="جلسه اجباری" :label-for="`isRequired`">
                    <b-form-checkbox
                      v-model="lessonDetails.isRequired"
                      :id="`isRequired`"
                    >
                      جلسه اجباری
                    </b-form-checkbox>
                  </b-form-group>
                  <!-- درس‌هایی که پشتیبانی تلفنی دارند؛ پکیج شامل آن‌ها هم پشتیبانی می‌گیرد -->
                  <b-form-group label="پشتیبانی تلفنی" label-for="needSupport">
                    <b-form-checkbox v-model="lessonDetails.needSupport" id="needSupport">
                      نیاز به پشتیبانی دارد
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="عکس کاور کلاس" label-for="imageFile">
                  <b-form-file
                    ref="imageInput"
                    id="imageFile"
                    @input="convertImageFileToBase64"
                    accept="image/*"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <div class="position-relative" v-if="imagePreview">
                  <img
                    style="width: 100%; max-height: 10rem; object-fit: contain"
                    :src="imagePreview"
                  />
                  <feather-icon
                    icon="Trash2Icon"
                    size="25"
                    class="text-danger position-absolute"
                    style="left: 1rem; top: 1rem; cursor: pointer"
                    @click="deletePreviewImage"
                  />
                </div>
              </b-col>
              <b-col cols="12" class="mt-2">
                <b-form-group
                  label-for="objectSkillType"
                  label="مشخص کردن نوع محتوا درس"
                >
                  <b-form-select
                    id="objectSkillType"
                    v-model="skillType"
                    :options="objectSkillTypesOptions"
                  ></b-form-select>
                </b-form-group>
                <div
                  class="w-100 d-flex align-items-center justify-content-end"
                >
                  <b-button variant="primary" @click="createObjectSkillType">
                    افزودن
                  </b-button>
                </div>
                <template v-if="skillTypesList && skillTypesList.length > 0">
                  <div
                    class="w-100 d-flex align-items-center"
                    style="gap: 0.5rem"
                  >
                    <b-badge
                      style="min-width: 13%; width: 15%; max-width: 25%"
                      class="p-1 d-flex align-items-center justify-content-between"
                      variant="info"
                      v-for="item in skillTypesList"
                      :key="item.objectSkillTypeId"
                    >
                      {{ objectSkillTypesEnum[item.skillType] }}
                      <b-button
                        variant="transparent"
                        type="button"
                        class="p-0"
                        @click="renderObjectSkillTypeDeleteConfirmation(item)"
                      >
                        <feather-icon
                          style="width: 1.1rem; height: 1.1rem"
                          icon="XIcon"
                          class="text-danger"
                        />
                      </b-button>
                    </b-badge>
                  </div>
                </template>
              </b-col>

              <b-col cols="12" class="mt-2">
                <div class="my-2">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="mb-0">رسانه های کلاس</p>
                    <div class="d-flex align-items-center">
                      <p class="mb-0 mr-1">نحوه نمایش:</p>
                      <div
                        @click="isGallery = true"
                        style="cursor: pointer"
                        class="d-flex align-items-center"
                      >
                        <p
                          class="mb-0"
                          :class="isGallery ? 'text-primary' : ''"
                        >
                          گالری
                        </p>
                        <feather-icon
                          icon="GridIcon"
                          size="15"
                          class="ml-1"
                          :class="isGallery ? 'text-primary' : ''"
                        />
                      </div>
                      <span class="mx-1">|</span>
                      <div
                        @click="isGallery = false"
                        :class="isGallery ? '' : 'text-primary'"
                        style="cursor: pointer"
                        class="d-flex align-items-center"
                      >
                        <p
                          class="mb-0"
                          :class="isGallery ? '' : 'text-primary'"
                        >
                          مجزا
                        </p>
                        <feather-icon
                          icon="ListIcon"
                          size="15"
                          class="ml-1"
                          :class="isGallery ? '' : 'text-primary'"
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </b-col>
              <lesson-media-list
                v-if="!isGallery"
                :videoFilesConcated="videoFilesConcated"
                :imageFilesConcated="imageFilesConcated"
                :audioFilesConcated="audioFilesConcated"
                :textFilesConcated="textFilesConcated"
                @deleteVideo="deleteVideo"
                @getVideoArray="setVideoArray"
                @deletePicture="deletePicture"
                @getImageArray="setImageArray"
                @getAudioArray="setAudioArray"
                @deleteAudio="deleteAudio"
                @getTextArray="setTextArray"
                @deleteText="deleteText"
                @refetch="getLessonMedias"
              ></lesson-media-list>
              <lesson-media-grid
                v-if="isGallery"
                :videoFilesConcated="videoFilesConcated"
                :imageFilesConcated="imageFilesConcated"
                :audioFilesConcated="audioFilesConcated"
                :textFilesConcated="textFilesConcated"
                @deleteVideo="deleteVideo"
                @getVideoArray="setVideoArray"
                @deletePicture="deletePicture"
                @getImageArray="setImageArray"
                @getAudioArray="setAudioArray"
                @deleteAudio="deleteAudio"
                @getTextArray="setTextArray"
                @deleteText="deleteText"
                @refetch="getLessonMedias"
              ></lesson-media-grid>
              <div class="w-100">
                <property-section
                  ref="property"
                  v-if="lessonDetails"
                  :courseTypeId="lessonDetails.course ? lessonDetails.course.courseTypeId : null"
                  :objectType="2"
                ></property-section>
              </div>
              <b-col cols="12">
                <div class="d-flex align-items-center justify-content-end">
                  <b-button variant="primary" @click="sendUpdateRequest"
                    >بروزرسانی</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </b-form>
          <div class="progress-wrapper" v-if="uploaded">
            <p class="mb-0">در حال آپلود {{ uploaded + "%" }}</p>
            <b-progress animated v-model="uploaded" max="100" />
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف رسانه"
      id="modal-media-delete"
      centered
      ok-title="حذف"
      cancel-title="بستن"
      @ok="sendMediaRemoveRequest"
    >
      آیا از حذف رسانه اطمینان دارید؟
    </b-modal>
    <b-modal
      id="object-skill-type-delete"
      title="حذف نوع محتوای درس"
      centered
      ok-title="حذف"
      cancel-title="بستن"
      @ok="removeObjectSkillType"
    >
      آیا از حذف نوع محتوای درس اطمینان دارید؟
    </b-modal>
  </b-overlay>
</template>
<script>
import {
  GetASingleLesson,
  UpdateASingleLesson,
  UploadLessonFiles,
  GetLessonMedias,
  DeleteLessonMedias,
} from "../../../libs/Api/Lesson";
import {
  CreateAnObjectSkillType,
  GetObjectSkillTypesOfProduct,
  DeleteObjectSkillType,
} from "@/libs/Api/ObjectSkillType";
import {
  CreateLessonQuestionsCount,
  GetAllLessonQuestionsCount,
  UpdateLessonQuestionsCount,
} from "../../../libs/Api/LessonQuestionsCount";
import { DeleteArvanVideo } from "@/libs/Api/ArvanCloud";
import LessonMediaList from "@/views/components/Lessons/LessonMediaList.vue";
import LessonMediaGrid from "@/views/components/Lessons/LessonMediaGrid.vue";
import PropertySection from "@/views/components/Properties/PropertySection.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BProgress,
  BFormTextarea,
  BFormCheckbox,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  async mounted() {
    await this.getALesson();
    this.getLessonMedias();
    this.getQuestionsCountForLesson();
    this.getAllObjectSkillTypes();
  },
  data() {
    return {
      // This value decide which component to load
      isGallery: false,
      lessonDetails: null,
      // the variable blow is needed to keep
      // previous data of lesson
      defaultLessonDetails: null,
      lessonMedias: null,
      isLoading: false,
      tempBase64: null,
      lessonImage: null,
      mediaFiles: [],
      // This Value (uploaded) is updated from WebServiceRequest class automatically
      uploaded: null,
      videoFiles: [],
      imageFiles: [],
      audioFiles: [],
      textFiles: [],
      // This variable must hold
      // String array during rendering
      // Of delete confirmation modal
      tempDeleteArray: null,
      isUpdatingLessonQuestionsCount: false,
      lessonQuestionsCount: {
        isDeleted: false,
        lessenQuestionsCountId: 0,
        lessonId: this.$route.params.id,
        easy: null,
        medium: null,
        hard: null,
        veryHard: null,
        createDate: new Date(Date.now()),
      },
      skillTypesList: null,
      // SkillType is the new value
      // That will be added
      skillType: null,
      objectSkillTypesEnum: {
        1: "شنیداری (Listening)",
        2: "گفتاری (Speaking)",
        3: "خواندن (Reading)",
        4: "نوشتاری (Writing)",
      },
      objectSkillTypesOptions: [
        // Listening = 1,
        // Speaking = 2,
        // Reading = 3,
        // Writing = 4,
        // All = 5
        {
          value: null,
          text: "در صورت تمایل یک گزینه را انتخاب کنید",
        },
        {
          value: 1,
          text: "شنیداری (Listening)",
        },
        {
          value: 2,
          text: "گفتاری (Speaking)",
        },
        {
          value: 3,
          text: "خواندن (Reading)",
        },
        {
          value: 4,
          text: "نوشتاری (Writing)",
        },
      ],
      // This variable is here to get
      // Removing item details
      tempObjectSkillType: null,
      tempVideoObject: null,
    };
  },
  methods: {
    async removeObjectSkillType() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteObjectSkillType = new DeleteObjectSkillType(_this);
        deleteObjectSkillType.setRequestParam({
          id: _this.tempObjectSkillType.objectSkillTypeId,
        });
        await deleteObjectSkillType.fetch(function (response) {
          if (response.isSuccess) {
            _this.getAllObjectSkillTypes();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderObjectSkillTypeDeleteConfirmation(item) {
      this.tempObjectSkillType = JSON.parse(JSON.stringify(item));
      this.$bvModal.show("object-skill-type-delete");
    },
    async createObjectSkillType() {
      try {
        this.isLoading = true;
        let _this = this;
        let createAnObjectSkillType = new CreateAnObjectSkillType(_this);
        createAnObjectSkillType.setRequestParamDataObj({
          isDeleted: false,
          objectSkillTypeId: 0,
          objectId: _this.$route.params.id,
          objectType: 1,
          skillType: _this.skillType,
          createDate: new Date(Date.now()),
        });
        await createAnObjectSkillType.fetch(function (response) {
          if (response.isSuccess) {
            _this.getAllObjectSkillTypes();
          }
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "نوع محتوای درس تکراری است",
            icon: "EditIcon",
            variant: "danger",
          },
        });
        console.error(error);
      } finally {
        this.skillType = null;
        this.isLoading = false;
      }
    },
    async getAllObjectSkillTypes() {
      try {
        this.isLoading = true;
        let _this = this;
        let getObjectSkillTypesOfProduct = new GetObjectSkillTypesOfProduct(
          _this
        );
        // SklillObjectType for lesson is 1, 2 is for course
        getObjectSkillTypesOfProduct.setRequestParam({
          count: 0,
          pageNumber: 0,
          skillObjectType: 1,
          objectId: _this.$route.params.id,
        });
        await getObjectSkillTypesOfProduct.fetch(function (response) {
          if (response.isSuccess) {
            _this.skillTypesList = response.data.objectSkillTypes;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    // async updateQuestionsCountForLesson() {
    //   try {
    //     let _this = this;
    //     let updateLessonQuestionsCount = new UpdateLessonQuestionsCount(_this);
    //     updateLessonQuestionsCount.setRequestParamDataObj(
    //       _this.lessonQuestionsCount
    //     );
    //     await updateLessonQuestionsCount.fetch(
    //       function (response) {
    //         console.log(response);
    //         _this.getQuestionsCountForLesson();
    //       },
    //       function (error) {
    //         console.error(error);
    //       }
    //     );
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    async getQuestionsCountForLesson() {
      try {
        let _this = this;
        let getAllLessonQuestionsCount = new GetAllLessonQuestionsCount(_this);
        getAllLessonQuestionsCount.setRequestParam({
          count: 0,
          pageNumber: 0,
          lessonId: _this.$route.params.id,
        });
        await getAllLessonQuestionsCount.fetch(
          function (response) {
            if (
              response.lessenQuestionsCounts &&
              response.lessenQuestionsCounts.length > 0
            ) {
              _this.isUpdatingLessonQuestionsCount = true;
              _this.lessonQuestionsCount = response.lessenQuestionsCounts[0];
            }
          },
          function (error) {
            console.log(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    async createQuestionsCountForLesson() {
      try {
        let _this = this;
        let createLessonQuestionsCount = new CreateLessonQuestionsCount(_this);
        createLessonQuestionsCount.setRequestParamDataObj([
          _this.lessonQuestionsCount,
        ]);
        await createLessonQuestionsCount.fetch(
          function (response) {
            _this.getQuestionsCountForLesson();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    async sendMediaRemoveRequest() {
      if (!this.tempVideoObject || !this.tempVideoObject.arvanCloudVideoId) {
        try {
          this.isLoading = true;
          let _this = this;
          let deleteLessonMedias = new DeleteLessonMedias(_this);
          deleteLessonMedias.setRequestParam({
            lessonId: _this.$route.params.id,
          });
          deleteLessonMedias.setRequestParamDataObj(_this.tempDeleteArray);
          await deleteLessonMedias.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "رسانه با موفقیت حذف شد.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
                _this.getLessonMedias();
              }
            },
            function (error) {
              console.error(error);
            }
          );
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      } else {
        this.sendDeleteArvanVideo();
      }
    },
    async sendDeleteArvanVideo() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteArvanVideo = new DeleteArvanVideo(_this);
        deleteArvanVideo.setRequestParam({
          videoId: _this.tempVideoObject.arvanCloudVideoId,
        });
        deleteArvanVideo.delete((response) => {
          if (response.isSuccess) {
            _this.tempVideoObject = null;
            _this.sendMediaRemoveRequest();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = true;
      }
    },
    deleteText(textFile) {
      if (typeof textFile === "object") {
        this.textFiles = this.textFiles.filter((item) => item != textFile);
      } else {
        this.tempDeleteArray = [textFile];
        this.$bvModal.show("modal-media-delete");
      }
    },
    deleteAudio(audioFile) {
      if (typeof audioFile === "object") {
        this.audioFiles = this.audioFiles.filter((item) => item != audioFile);
      } else {
        this.tempDeleteArray = [audioFile];
        this.$bvModal.show("modal-media-delete");
      }
    },
    deletePicture(pictureFile) {
      if (typeof pictureFile === "object") {
        this.imageFiles = this.imageFiles.filter((item) => item != pictureFile);
      } else {
        this.tempDeleteArray = [pictureFile];
        this.$bvModal.show("modal-media-delete");
      }
    },
    deleteVideo(videoFile) {
      if (videoFile && !videoFile.mediaId) {
        this.videoFiles = this.videoFiles.filter((item) => item != videoFile);
      } else {
        this.tempVideoObject = videoFile;
        this.tempDeleteArray = [videoFile.pictureUrl];
        this.$bvModal.show("modal-media-delete");
      }
    },
    setTextArray(textArray) {
      textArray.forEach((item) => this.textFiles.push(item));
    },
    setAudioArray(audioArray) {
      audioArray.forEach((item) => this.audioFiles.push(item));
    },
    setImageArray(imageArray) {
      imageArray.forEach((item) => this.imageFiles.push(item));
    },
    setVideoArray(videoArray) {
      videoArray.forEach((item) => this.videoFiles.push(item));
    },
    async getLessonMedias() {
      let _this = this;
      let getLessonMedias = new GetLessonMedias(_this);
      getLessonMedias.setRequestParam({
        lessonId: _this.$route.params.id,
      });
      await getLessonMedias.fetch(
        function (response) {
          _this.lessonMedias = response.data;
        },
        function (error) {
          console.error(error);
        }
      );
    },
    handleMediaView(file) {
      // Deciding whether file is blob or url
      if (typeof file === "object") {
        return URL.createObjectURL(file);
      } else if (typeof file === "string") {
        return `${this.baseUrl}/${file}`;
      }
    },
    async uploadLessonMedias() {
      try {
        let formData = new FormData();
        for (let i = 0; i < this.mediaFiles.length; i++) {
          formData.append("files", this.mediaFiles[i]);
        }
        let _this = this;
        let uploadLessonFiles = new UploadLessonFiles(_this);
        uploadLessonFiles.setRequestParam({
          lessonId: _this.$route.params.id,
        });
        uploadLessonFiles.setFormData(formData);
        await uploadLessonFiles.sendFormData(
          function (response) {
            _this.uploaded = null;
            _this.videoFiles = [];
            _this.imageFiles = [];
            _this.audioFiles = [];
            _this.textFiles = [];
            _this.getLessonMedias();
            _this.getALesson();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error.response.data);
      }
    },
    async sendUpdateRequest() {
      // Push all media files together
      this.mediaFiles = [
        ...this.videoFiles,
        ...this.audioFiles,
        ...this.imageFiles,
        ...this.textFiles,
      ];
      try {
        this.lessonDetails.imageFile = this.tempBase64;
        this.isLoading = true;
        let _this = this;
        let updateASingleLesson = new UpdateASingleLesson(_this);
        _this.lessonDetails.dependency = null;
        updateASingleLesson.setRequestParamDataObj(_this.lessonDetails);
        await updateASingleLesson.fetch(
          function (response) {
            if (_this.mediaFiles && _this.mediaFiles.length > 0) {
              let size = 0;
              _this.mediaFiles.forEach((file) => (size += file.size));
              const sizeInMb = size / 1024 / 1024;
              if (sizeInMb > 500) {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "مشکل در آپلود",
                    text: "حجم فایل های ارسالی به صورت کلی نباید بیشتر از 500 مگابایت باشد!",
                    icon: "EditIcon",
                    variant: "danger",
                  },
                });
              } else {
                _this.uploadLessonMedias();
              }
            }
            _this.$refs.property.createPropertyList();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    deletePreviewImage() {
      if (this.lessonDetails.imageFile != this.lessonImage) {
        this.tempBase64 = null;
        this.lessonImage = this.lessonDetails.imageFile;
      } else {
        this.tempBase64 = `${this.lessonDetails.imageFile}Delete`;
        this.lessonImage = null;
      }
      this.$refs.imageInput.reset();
    },
    convertImageFileToBase64(file) {
      if (file) {
        this.lessonImage = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          this.tempBase64 = reader.result.split(",")[1];
        };
      }
    },
    async getALesson() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleLesson = new GetASingleLesson(_this);
        getASingleLesson.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleLesson.fetch(
          function (response) {
            _this.defaultLessonDetails = response.data;
            _this.lessonDetails = JSON.parse(
              JSON.stringify(_this.defaultLessonDetails)
            );
            _this.lessonImage = _this.lessonDetails.imageFile;
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    // These computed concated functions return new file blobs
    // And old uploaded files together
    videoFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.videos) ||
        (this.videoFiles && this.videoFiles.length > 0)
      ) {
        return [...this.lessonMedias.videos, ...this.videoFiles];
      }
    },
    imageFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.images) ||
        (this.imageFiles && this.imageFiles.length > 0)
      ) {
        return [...this.lessonMedias.images, ...this.imageFiles];
      }
    },
    audioFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.podcasts) ||
        (this.audioFiles && this.audioFiles.length > 0)
      ) {
        return [...this.lessonMedias.podcasts, ...this.audioFiles];
      }
    },
    textFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.pdFs) ||
        (this.textFiles && this.textFiles.length > 0)
      ) {
        return [...this.lessonMedias.pdFs, ...this.textFiles];
      }
    },
    imagePreview() {
      if (
        this.lessonImage &&
        this.lessonImage.length > 0 &&
        this.lessonImage !== null &&
        typeof this.lessonImage === "string" &&
        this.lessonImage.includes(".")
      ) {
        return `${this.baseUrl}/${this.lessonImage}`;
      } else if (
        this.lessonImage !== null &&
        this.lessonImage !== null &&
        typeof this.lessonImage === "object"
      ) {
        return URL.createObjectURL(this.lessonImage);
      } else {
        return null;
      }
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    LessonMediaList,
    LessonMediaGrid,
    PropertySection,
    BProgress,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BFormSelect,
  },
};
</script>
